
import { defineComponent } from "@vue/runtime-core";
import { mapMutations,mapState } from "vuex";

export default defineComponent({
  name:'Header',
  methods:{
    ...mapMutations(['toggleAuthModal']),
    async logOut(){
      // logout   
      await this.$store.dispatch('logOut')

      // check if the current route needs auth then redirect else stay
      if(this.$route.meta.requiresAuth){
        this.$router.push({name:'Home'})
      }
    }
  },
  computed:{
    ...mapState(['isLoggedIn','isMobile'])
  }
})
